import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";
import { CrossIcon } from "@/components/common/icons";
import { PRIMARY } from "@/config/mui/colorPalette";

export type DialogWithCloseButtonProps = {
  isOpen: boolean;
  title: string;
  content: ReactNode;
  cancelButtonText?: string;
  primaryButtonText: string;
  handlePrimaryClick: () => void;
  handleCancel: () => void;
  loading?: boolean;
};

export default function DialogWithCloseButton({
  isOpen,
  title,
  content,
  cancelButtonText = "Cancel",
  primaryButtonText,
  handlePrimaryClick,
  handleCancel,
  loading = false,
}: DialogWithCloseButtonProps) {
  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        sx: {
          p: 2,
          borderRadius: 4,
          width: "400px",
        },
      }}
    >
      <DialogTitle sx={{ p: 0, pb: 2 }}>
        <Stack direction="row" sx={{ alignItems: "center" }}>
          <Box sx={{ flex: "0 0 24px" }} />
          <Typography variant="h3" textAlign="center" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <IconButton onClick={handleCancel} sx={{ p: 0 }}>
            <CrossIcon size={24} color={PRIMARY} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{
          textAlign: "center",
          p: 0,
          pb: 3,
        }}
      >
        {content}
      </DialogContent>
      <DialogActions
        sx={{
          p: 0,
          "& > *": {
            width: "100%",
          },
        }}
      >
        <Button
          variant="outlined"
          size="small"
          color="secondary"
          onClick={handleCancel}
          loading={loading}
        >
          {cancelButtonText}
        </Button>
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={handlePrimaryClick}
          loading={loading}
        >
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
